export const TRADITION_TOUR = [
  {
    anchorId: "step.one",
    content:"<p class='tourtext'>Primero ingresa tu código postal para consultar el seguro de tu auto</p>",
    title: "1/2",
    prevBtnTitle: 'Anterior',
    nextBtnTitle: 'Siguiente',
    enableBackdrop: true,
    disablePageScrolling: true,
    close:false,
  },
  {
    anchorId: "step.two",
    content:"<p class='tourtext tourbt10'>Ingresa el monto de enganche que más te convenga</p> <span>(sujeto a aprobación de crédito)</span>",
    title: "2/2",
    prevBtnTitle: 'Anterior',
    nextBtnTitle: 'Siguiente',
    endBtnTitle: '¡Entendido!',
    enableBackdrop: true,
    disablePageScrolling: true,
  },
  /* TODO: FASE 2 */
  {
    anchorId: "step.three",
    content: "<p class='tourtext'>Al incluir anualidades podrás seleccionar el monto y el mes del año para reducir el resto de tus mensualidades</p>",
    title: "3/5",
    prevBtnTitle: 'Anterior',
    nextBtnTitle: 'Siguiente',
    enableBackdrop: true,
    disablePageScrolling: true,
  },
  {
    anchorId: "step.four",
    content: "<p class='tourtext'>Incluye el rastreo base para activar la localización satelital en tu vehículo en caso de robo</p>",
    title: "4/5",
    prevBtnTitle: 'Anterior',
    nextBtnTitle: 'Siguiente',
    enableBackdrop: true,
    disablePageScrolling: true,
  },
  {
    anchorId: "step.five",
    content: "<p class='tourtext'>Incluye los mantenimientos de tu auto durante el kilometraje seleccionado</p>",
    title: "5/5",
    prevBtnTitle: 'Anterior',
    nextBtnTitle: 'Siguiente',
    endBtnTitle: '¡Entendido!',
    enableBackdrop: true,
    disablePageScrolling: true,
  },
  /* TODO: FASE 2 */
];

export const BALLON_TOUR = [
  {
    anchorId: "step.one",
    content:"<p class='tourtext'>Primero ingresa tu código postal para consultar el seguro de tu auto</p>",
    title: "1/2",
    prevBtnTitle: 'Anterior',
    nextBtnTitle: 'Siguiente',
    enableBackdrop: true,
    close:false,
    disablePageScrolling: true,
  },
  {
    anchorId: "step.two",
    content:"<p class='tourtext tourbt10'>Ingresa el monto de enganche que más te convenga</p> <span>(sujeto a aprobación de crédito)</span>",
    title: "2/2",
    prevBtnTitle: 'Anterior',
    nextBtnTitle: 'Siguiente',
    endBtnTitle: '¡Entendido!',
    enableBackdrop: true,
    disablePageScrolling: true,
  },
  // TODO: COMENTADO PARA LA PRIMERA VERSIÓN
  // {
  //   anchorId: "step.threeB",
  //   content: "<p class='tourtext'>Un mayor pago final disminuye tu mensualidad</p>",
  //   title: "3/5",
  //   prevBtnTitle: 'Anterior',
  //   nextBtnTitle: 'Siguiente',
  //   enableBackdrop: true,
  //   disablePageScrolling: true,
  // },
  // {
  //   anchorId: "step.four",
  //   content: "<p class='tourtext'>Incluye el rastreo base para activar la localización satelital en tu vehículo en caso de robo</p>",
  //   title: "4/5",
  //   prevBtnTitle: 'Anterior',
  //   nextBtnTitle: 'Siguiente',
  //   enableBackdrop: true,
  //   disablePageScrolling: true,
  // },
  // {
  //   anchorId: "step.five",
  //   content: "<p class='tourtext'>Incluye los mantenimientos de tu auto durante el kilometraje seleccionado</p>",
  //   title: "5/5",
  //   prevBtnTitle: 'Anterior',
  //   nextBtnTitle: 'Siguiente',
  //   endBtnTitle: '¡Entendido!',
  //   enableBackdrop: true,
  //   disablePageScrolling: true,
  // },
];